import { cncAccionesRoles } from '../../acciones-roles/departamentos/cnc-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const CNCRoutes: SideBarButton = {
  data: {
    name: 'CNC',
    appendUrl: './cnc',
    roles: cncAccionesRoles.sideNavActions.main,
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Proceso',
        url: '/scheduler',
        roles: cncAccionesRoles.routerActions.schedulingRoot,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Limpieza',
        url: '/scheduler/cleaning',
        roles: cncAccionesRoles.sharedActions.cleaning,
      },
      options: PreConfigButton3,
    },
    // {
    //   data: {
    //     name: 'Calidad',
    //     url: '/quality-control',
    //     roles: cncAccionesRoles.sharedActions.qualityControl,
    //   },
    //   options: PreConfigButton3,
    // },
    {
      data: {
        name: 'Proyectos',
        url: '/projects',
        roles: cncAccionesRoles.sharedActions.cncProjects,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Validacion',
        url: '/validation',
        roles: cncAccionesRoles.sharedActions.cncValidation,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Etiquetas',
        url: '/packing-box',
        roles: cncAccionesRoles.sharedActions.packingBox,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Agregar Datos QC',
        url: '/qc-data',
        roles: cncAccionesRoles.sharedActions.qcData,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Bolbar',
        url: '/bolbar',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte Spindle',
        overWriteUrl: './reportsPBI/cnc/spindle',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte BolBar',
        overWriteUrl: './reportsPBI/cnc/bolbar',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte Power BI',
        overWriteUrl: './reportsPBI/cnc',
      },
      options: PreConfigButton3,
    },
  ],
};
